import { AxiosError } from 'axios';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '../../../../../../components/Modal';
import {
  backendErrorNotification,
  frontendNotification,
} from '../../../../../../components/Notification';
import { NotificationTypes } from '../../../../../../components/Notification/notificationEnums';
import HttpStatus from '../../../../../../enums/httpStatus';
import { apiKeysReq, deleteApiKeyReq } from '../../../../../../services/requests';
import { ApiKey } from '../../../../../../types';

type Props = {
  showModal: boolean;
  closeModal: () => void;
  callback: () => void;
  apiKeySelected: ApiKey;
};

const DeleteApiKeyModal = ({
  showModal,
  closeModal,
  callback,
  apiKeySelected,
}: Props) => {
  const { t } = useTranslation();

  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const reqDeleteApiKey = async () => {
    setIsLoading(true);

    try {
      const response = await deleteApiKeyReq(apiKeySelected.code, password);

      if (response.status === HttpStatus.OK) {
        frontendNotification({
          message: t('deletedApiKey'),
          type: NotificationTypes.SUCCESS,
        });

        callback();
        closeModal();
        setPassword('');
      } else {
        throw response;
      }
    } catch (err) {
      if (!apiKeysReq.axios.isCancel(err)) {
        backendErrorNotification(err as AxiosError<any, any>);
      }
    }

    setIsLoading(false);
  };

  return (
    <Modal
      title={t('deleteApiKey')}
      showModal={showModal}
      closeModal={closeModal}
      cancelButton={closeModal}
      action={reqDeleteApiKey}
      actionNameBtn={t('delete')}
      disableActionBtn={!password}
      isLoading={isLoading}
      bodyStyle={{ overflow: 'scroll' }}
    >
      <div className="row">
        <div className="inputWithoutLabel">
          <p>{t('deleteApiKeySure')}</p>
          <b>{apiKeySelected.name}</b>
        </div>
      </div>

      <div className="row">
        <div className="inputWithLabel">
          <p className="label">{t('password') as string}</p>
          <input
            className="input"
            type="password"
            value={password}
            onChange={
              (event: ChangeEvent<HTMLInputElement>) => setPassword(event.currentTarget.value)
            }
          />
        </div>
      </div>
    </Modal>
  );
};

export default DeleteApiKeyModal;